import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import {
  useGetCalendarLink,
  useGetCategoriesLink,
  useGetDistributionsLink,
  useGetExperimentsLink,
  useGetGameEnvironmentsLink,
  useGetGameVersionsLink,
  useGetSelectionsLink
} from '../../routes';
import { NavigationRail } from '@yakoffice/navigation-rail';
import type { PublisherLinkOverrides } from '@yakoffice/navigation-rail';

export const NavigationRailLoader: FC = observer(() => {

  const getGameEnvironmentsLink = useGetGameEnvironmentsLink();
  const getCategoriesLink = useGetCategoriesLink();
  const getExperimentsLink = useGetExperimentsLink();
  const getSelectionsLink = useGetSelectionsLink();
  const getDistributionsLink = useGetDistributionsLink();
  const getCalendarLink = useGetCalendarLink();
  const getGameVersionsLink = useGetGameVersionsLink();

  const getPublisherLinks = (): PublisherLinkOverrides => {
    return {
      categories: getCategoriesLink(),
      distributions: getDistributionsLink(),
      experiments: getExperimentsLink(),
      calendar: getCalendarLink(),
      selections: getSelectionsLink(),
      gameEnvironments: getGameEnvironmentsLink(),
      gameVersions: getGameVersionsLink()
    };
  };

  return <NavigationRail toolId="publisher" publisherLinkOverrides={getPublisherLinks()} />;
});
